import { MachineVariables } from './binding/binding.types';
import {
  MonitorRealtimeDataConfig,
  useMonitorRealtimeData,
} from './monitor-realtime-data.hooks';

interface MachineVariablesHookProps {
  id?: string;
  config?: MonitorRealtimeDataConfig;
}

const useMachineVariables = (
  props: MachineVariablesHookProps
): MachineVariables => {
  const data = useMonitorRealtimeData(props.id, props.config);
  const variables = data.variables;
  return variables ?? {};
};

export { useMachineVariables };
